import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';
import { CallToActionConstants } from '../Constants';


const CallToActionIcon = ({
  disabled
}) => (
  <svg width="25px" height="25px" viewBox="0 0 22 17" className={Classes.genericIcon}>
    <g transform="translate(-1065.000000, -1886.000000)" >
      <g transform="translate(1055.000000, 1877.000000)"className={Classes.contactUsFill}>
        {!disabled ?
          <path d={CallToActionConstants.addressLightIcon} /> :
          <path d={CallToActionConstants.addressSolidIcon} />}
      </g>
    </g>
  </svg>
);
CallToActionIcon.propTypes = {
  disabled: PropTypes.bool.isRequired
};

export default CallToActionIcon;
